import { Box, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';

// Student Information Page - page displaying student information (coordinator/admin view)
function StudentInformation(props) {
    const [studentName, setStudentName] = useState('Jane Doe');
    const [email, setEmail] = useState('example@knights.ucf.edu');
    const [group, setGroup] = useState('Example Group');
    const [role, setRole] = useState('example role');
    const [attendanceStats, setAttendanceStats] = useState({});
    const [attendanceData, setAttendanceData] = useState([]);

    let navigate = useNavigate();
    const { state } = useLocation();

    async function getUserData() {
        const userData = await axios.get(`${process.env.REACT_APP_API_HOST}/api/user/${state.user_id}`,
            {
                headers: {Authorization: `Bearer ${state.token.access_token}`},
            }
        );
        setStudentName(userData.data.first_name + " " + userData.data.last_name);
        setRole(userData.data.role);
        setEmail(userData.data.email || "No email found");
        setGroup(userData.data.group);

        if (userData.data.group) {
            setAttendanceStats({
                totalMeetings: userData.data.group.total_meetings,
                meetings_attended: userData.data.meetings_attended
            })

            const attendanceData = await axios.get(`${process.env.REACT_APP_API_HOST}/api/groups/attendance/${userData.data.group.group_id}`,
            {
                headers: {Authorization: `Bearer ${state.token.access_token}`},
            });
            setAttendanceData(attendanceData.data);
        }
    }

    useEffect(() => {
        getUserData();
    }, []);


    return (
        <Box>
            <DashboardNavbar userType='admin' />
            <Stack spacing={2} sx={{ px: 3, my: 3, marginInline: "auto", maxWidth: 1000}}>
                <Typography variant='h4'>{studentName}</Typography>
                <Stack spacing={2}>
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant='body' sx={{ textAlign: 'right', width: '115px', fontWeight: 'bold' }}>Email: </Typography>
                        <Link variant='body' href={'mailto:' + email} sx={{ textAlign: 'left', ml: '.25em'}}>{email}</Link>
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant='body' sx={{ textAlign: 'right', width: '115px', fontWeight: 'bold' }}>Project/Group: </Typography>
                        {/* TODO: Link navigates to coordinator view of team view page */}
                        <Link variant='body' sx={{ textAlign: 'left', ml: '.25em' }}>{group?.project?.name || "No group found"}</Link>
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant='body' sx={{ textAlign: 'right', width: '115px', fontWeight: 'bold' }}>Role: </Typography>
                        <Typography variant='body' sx={{ textAlign: 'left', ml: '.25em' }}>{role || "No role found"}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant='body' sx={{ textAlign: 'right', width: '115px', fontWeight: 'bold' }}>Attendance: </Typography>
                        <Typography variant='body' sx={{ textAlign: 'left', ml: '.25em' }}>{(attendanceStats.meetings_attended || 0) + " / " + (attendanceStats.totalMeetings || 0)}</Typography>
                    </Box>
                    <TableContainer>
                        <Table sx={{ bgcolor: '#E9E9E9'}}>
                            <TableHead >
                                <TableRow >
                                    <TableCell sx={{ fontWeight: 'bold', fontSize: 18}}>Date:</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', fontSize: 18}}>Subject:</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', fontSize: 18}}>Status:</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {attendanceData && attendanceData.map((record) => (
                                    <TableRow>
                                        <TableCell>{record.date}</TableCell>
                                        <TableCell>{record.meeting_subject}</TableCell>
                                        <TableCell>{record.attendance_status[state.user_id] ? "Present" : "Absent"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Stack>
            </Stack>
        </Box>
    );
}

export default StudentInformation;